module.exports = {
    "source_code": "HLXEMS",
    "site_id": "mba.stetson.edu",
    "title": "Stetson University",
    "tfn": "#",
    "url": "https://mba.stetson.edu/",
    "gtm_code": "GTM-W2CMGLTW",
}